/**
 * Maps sidebar path (or path prefix) to backend permission module key.
 * Aligned with new sidebar groups and modules.
 */
export const PATH_TO_MODULE_KEY: Record<string, string> = {
  '/dashboard': 'vessel_dashboard',
  '/requisitions': 'vessel_supply_requisitions',
  '/pending-deliveries': 'vessel_pending_deliveries',
  '/spare-requisitions': 'vessel_spare_requisitions',
  '/spare-pending-deliveries': 'vessel_spare_pending_deliveries',
  '/crew': 'vessel_crew',
  '/wrh': 'vessel_wrh',
  '/mga': 'vessel_mga',
  '/examples/items': 'examples',
  '/emails': 'emails',
  '/chat': 'chat',
  '/email-accounts': 'email_accounts',
  '/email-signatures': 'email_signatures',
  '/search-folders': 'search_folders',
  '/admin/email-logs': 'email_logs',
  '/todos': 'todos',
  '/todos_monthly_view': 'todos',
  '/crm_tasks': 'crm_tasks',
  '/crm_tasks-monthly': 'crm_tasks',
  '/projects': 'projects',
  '/support-ticket': 'support_ticket',
  '/knowledge-base': 'knowledge_base',
  '/crm_notes': 'crm_notes',
  '/cardboard-crm-notes': 'crm_notes',
  '/client-vault': 'client_vault',
  '/vault-templates': 'vault_templates',
  '/clients': 'clients',
  '/leads': 'leads',
  '/offers': 'offers',
  '/catalog-items': 'catalog_items',
  '/offer-templates': 'offer_templates',
  '/settings/offer-pdf-layouts': 'offer_templates',
  '/calls': 'calls',
  '/appointments': 'appointments',
  '/appointments_calendar_view': 'appointments',
  '/marketing': 'marketing',
  '/client-invoices': 'client_invoices',
  '/invoice-payments': 'invoice_payments',
  '/supplier-invoices': 'supplier_invoices',
  '/entities': 'suppliers',
  '/suppliers': 'suppliers',
  '/parameters/crew': 'crew_parameters',
  '/supplier-invoice-payments': 'supplier_payments',
  '/parameters/countries': 'countries',
  '/parameters/currencies': 'currencies',
  '/parameters/departments': 'departments',
  '/parameters/store-categories': 'store_categories',
  '/parameters/vessels': 'vessels',
  '/parameters/ports': 'ports',
  '/vessel-modules/dashboard': 'vessel_dashboard',
  '/vessel-modules': 'vessel_supply_requisitions',
  '/supplies/requisitions': 'supply_requisitions',
  '/supplies/supplier-enquiries': 'supplier_enquiries',
  '/supplies/excel-document-templates': 'supply_requisitions',
  '/supplies/reference-templates': 'supply_requisitions',
  '/supplies/supplier-quotations': 'supplier_quotations',
  '/supplies/quotation-evaluations': 'quotation_evaluations',
  '/supplies/supply-purchase-orders': 'supply_purchase_orders',
  '/supplies/supply-forwarding-statuses': 'supply_forwarding_statuses',
  '/supplies/supply-forwardings': 'supply_forwardings',
  '/supplies/supply-deliveries': 'supply_deliveries',
  '/supplies/supply-invoices': 'supply_invoices',
  '/supplies/supply-cases': 'supply_cases',
  '/supplies/items': 'store_items',
  '/supplies/store-catalogs': 'store_catalogs',
  '/supplies/item-units': 'store_units',
  '/spares/requisitions': 'spare_requisitions',
  '/spares/supplier-enquiries': 'spare_supplier_enquiries',
  '/spares/reference-templates': 'spare_requisitions',
  '/spares/supplier-quotations': 'spare_supplier_quotations',
  '/spares/quotation-evaluations': 'spare_quotation_evaluations',
  '/spares/spare-purchase-orders': 'spare_purchase_orders',
  '/spares/spare-forwarding-statuses': 'spare_forwarding_statuses',
  '/spares/spare-forwardings': 'spare_forwardings',
  '/spares/spare-deliveries': 'spare_deliveries',
  '/spares/spare-invoices': 'spare_invoices',
  '/spares/spare-cases': 'spare_cases',
  '/spares/spare-items': 'spare_items',
  '/spares/spare-libraries': 'spare_libraries',
  '/accounting': 'accounting',
  '/accounting/journals': 'acc_documents',
  '/accounting/payments/new': 'acc_documents',
  '/accounting/payments': 'acc_documents',
  '/accounting/journal-types': 'acc_document_types',
  '/accounting/account-types': 'acc_account_types',
  '/accounting/operational-types': 'acc_operational_types',
  '/accounting/companies': 'acc_companies',
  '/accounting/coa': 'acc_accounts',
  '/accounting/statement-lines': 'acc_accounts',
  '/accounting/periods': 'acc_periods',
  '/accounting/currency-rates': 'acc_currency_rates',
  '/accounting/reports': 'accounting',
  '/accounting/reports/analytical-ledgers': 'accounting',
  '/accounting/reports/journal-register': 'accounting',
  '/accounting/reports/journal': 'accounting',
  '/accounting/reports/general-ledger': 'accounting',
  '/accounting/reports/ledger-kartela': 'accounting',
  '/accounting/reports/link-statement': 'accounting',
  '/accounting/reports/trial-balance': 'accounting',
  '/accounting/reports/trial-balance-by-company': 'accounting',
  '/accounting/reports/open-items': 'accounting',
  '/accounting/reports/aging': 'accounting',
  '/accounting/reports/profit-and-loss': 'accounting',
  '/accounting/reports/balance-sheet': 'accounting',
  '/accounting/reports/intercompany': 'accounting',
  '/accounting/reports/running-cost-by-vessel': 'accounting',
  '/accounting/reports/department-analysis': 'accounting',
  '/accounting/reports/period-close-checklist': 'accounting',
  '/accounting/reports/audit-trail': 'accounting',
  '/payees': 'payees',
  '/payees-projection': 'payees_projection',
  '/recurring-payables': 'recurring_payables',
  '/expenses': 'expenses',
  '/expenses-summary': 'expenses',
  '/expense-categories': 'expense_categories',
  '/p_crm_expense_category': 'expense_categories',
  '/p_crm_expense_subcategory': 'expense_subcategories',
  '/packages': 'packages',
  '/support-agreements': 'support_agreements',
  '/client-services': 'client_services',
  '/client-services-yearly': 'client_services',
  '/service_renewal_reminders': 'client_services',
  '/task_type': 'task_type',
  '/task_category': 'task_category',
  '/task_status': 'task_status',
  '/priority': 'priority',
  '/ticket_status': 'ticket_status',
  '/call_type': 'call_type',
  '/service_type': 'service_type',
  '/frequency_type': 'frequency_type',
  '/duration': 'duration',
  '/p_crm_service_category': 'service_category',
  '/reminder_type': 'reminder_type',
  '/tax_authority': 'tax_authority',
  '/p_country': 'p_country',
  '/app_status': 'app_status',
  '/p_crm_invoice_category': 'invoice_category',
  '/p_crm_invoice_type': 'invoice_type',
  '/manufacturer': 'manufacturer',
  '/catalog-category': 'catalog_category',
  '/tags': 'tags',
  '/admin/users': 'users',
  '/admin/database-browser': 'database_browser',
  '/admin/import-actions/impa-code': 'import_impa',
  '/admin/import-actions/accounts-plan': 'import_accounts_plan',
  '/admin/import-actions/companies': 'import_companies',
  '/admin/import-actions/journals': 'import_journals',
  '/presets-management': 'presets_management',
  '/settings': 'settings',
  '/admin/settings/files-storage': 'deleted_files',
  '/admin/settings/deleted-files': 'deleted_files',
  '/admin/settings/system-email-templates': 'settings',
  '/admin/settings/email-notifications': 'settings',
  '/configuration-settings': 'configuration_settings',
  '/activity-logs': 'activity_logs',
  '/notifications': 'notifications',
  '/workflows': 'workflows',
  '/custom-fields': 'custom_fields',
  '/tools/gemi-preview': 'import_gemi',
  '/tools/11888-preview': 'import_11888',
  '/tools/database-browser': 'database_browser', // legacy path
  '/import/invoice': 'import_invoice',
  '/reports/ReportGenerator': 'report_generator',
  '/reports/InvoicesByYear': 'reports',
  '/reports/InvoicesPaymentAnalysis': 'reports',
  '/reports/ExpensesByYear': 'reports',
  '/reports/Unpaid': 'reports',
  '/reports/AppointmentsReport': 'reports',
  '/reports/CallsReport': 'reports',
  '/reports/MissedCalls': 'reports',
  '/reports/MonthlyServices': 'reports',
  '/reports/ClientTasksMonthly': 'reports',
  '/reports/TodosMonthlyReport': 'reports',
};

export const LANDING_MODULE_ORDER = [
  'dashboard',
  'vessel_dashboard',
  'supply_cases',
  'supply_requisitions',
  'vessel_supply_requisitions',
  'vessel_pending_deliveries',
  'vessel_spare_requisitions',
  'vessel_spare_pending_deliveries',
  'vessel_crew',
  'supplier_enquiries',
  'supplier_quotations',
  'quotation_evaluations',
  'supply_purchase_orders',
  'supply_forwardings',
  'supply_deliveries',
  'supply_invoices',
  'supply_forwarding_statuses',
  'spare_cases',
  'spare_requisitions',
  'spare_supplier_enquiries',
  'spare_supplier_quotations',
  'spare_quotation_evaluations',
  'spare_purchase_orders',
  'spare_forwardings',
  'spare_deliveries',
  'spare_invoices',
  'spare_forwarding_statuses',
  'spare_libraries',
  'spare_items',
  'store_items',
  'store_catalogs',
  'store_categories',
  'store_units',
  'vessels',
  'ports',
  'countries',
  'currencies',
  'departments',
  'crew_parameters',
  'suppliers',
  'crew',
  'users',
  'import_impa',
  'import_accounts_plan',
  'import_companies',
  'import_journals',
  'database_browser',
] as const;

export type LandingModuleKey = (typeof LANDING_MODULE_ORDER)[number];

export const LANDING_MODULE_LABELS: Record<LandingModuleKey, string> = {
  dashboard: 'Dashboard',
  vessel_dashboard: 'Dashboard',
  supply_cases: 'Supply cases',
  supply_requisitions: 'Supply requisitions',
  vessel_supply_requisitions: 'Vessel requisitions',
  vessel_pending_deliveries: 'Vessel pending deliveries',
  vessel_spare_requisitions: 'Vessel spare requisitions',
  vessel_spare_pending_deliveries: 'Vessel spare pending deliveries',
  vessel_crew: 'Vessel crew',
  supplier_enquiries: 'RFQ',
  supplier_quotations: 'Quotations',
  quotation_evaluations: 'Evaluations',
  supply_purchase_orders: 'Purchase orders',
  supply_forwardings: 'Supply forwardings',
  supply_deliveries: 'Supply deliveries',
  supply_invoices: 'Supply invoices',
  supply_forwarding_statuses: 'Forwarding statuses',
  spare_cases: 'Spare cases',
  spare_requisitions: 'Spare requisitions',
  spare_supplier_enquiries: 'Spare RFQ',
  spare_supplier_quotations: 'Spare quotations',
  spare_quotation_evaluations: 'Spare evaluations',
  spare_purchase_orders: 'Spare purchase orders',
  spare_forwardings: 'Spare forwardings',
  spare_deliveries: 'Spare deliveries',
  spare_invoices: 'Spare invoices',
  spare_forwarding_statuses: 'Spare forwarding statuses',
  spare_libraries: 'Spare libraries',
  spare_items: 'Spare items',
  store_items: 'Store items',
  store_catalogs: 'Store catalogs',
  store_categories: 'Store categories',
  store_units: 'Store item units',
  vessels: 'Vessels',
  ports: 'Ports',
  countries: 'Countries',
  currencies: 'Currencies',
  departments: 'Departments',
  crew_parameters: 'Crew parameters',
  suppliers: 'Entities',
  crew: 'Crew Pool',
  users: 'User management',
  import_impa: 'IMPA import',
  import_accounts_plan: 'Accounts plan import',
  import_companies: 'Companies import',
  import_journals: 'Journals import',
  database_browser: 'Database browser',
};

const LANDING_MODULE_PATHS: Record<LandingModuleKey, string> = {
  dashboard: '/dashboard',
  vessel_dashboard: '/dashboard',
  supply_cases: '/supplies/supply-cases',
  supply_requisitions: '/supplies/requisitions',
  vessel_supply_requisitions: '/requisitions',
  vessel_pending_deliveries: '/pending-deliveries',
  vessel_spare_requisitions: '/spare-requisitions',
  vessel_spare_pending_deliveries: '/spare-pending-deliveries',
  vessel_crew: '/crew',
  supplier_enquiries: '/supplies/supplier-enquiries',
  supplier_quotations: '/supplies/supplier-quotations',
  quotation_evaluations: '/supplies/quotation-evaluations',
  supply_purchase_orders: '/supplies/supply-purchase-orders',
  supply_forwardings: '/supplies/supply-forwardings',
  supply_deliveries: '/supplies/supply-deliveries',
  supply_invoices: '/supplies/supply-invoices',
  supply_forwarding_statuses: '/supplies/supply-forwarding-statuses',
  spare_cases: '/spares/spare-cases',
  spare_requisitions: '/spares/requisitions',
  spare_supplier_enquiries: '/spares/supplier-enquiries',
  spare_supplier_quotations: '/spares/supplier-quotations',
  spare_quotation_evaluations: '/spares/quotation-evaluations',
  spare_purchase_orders: '/spares/spare-purchase-orders',
  spare_forwardings: '/spares/spare-forwardings',
  spare_deliveries: '/spares/spare-deliveries',
  spare_invoices: '/spares/spare-invoices',
  spare_forwarding_statuses: '/spares/spare-forwarding-statuses',
  spare_libraries: '/spares/spare-libraries',
  spare_items: '/spares/spare-items',
  store_items: '/supplies/items',
  store_catalogs: '/supplies/store-catalogs',
  store_categories: '/parameters/store-categories',
  store_units: '/supplies/item-units',
  vessels: '/parameters/vessels',
  ports: '/parameters/ports',
  countries: '/parameters/countries',
  currencies: '/parameters/currencies',
  departments: '/parameters/departments',
  crew_parameters: '/parameters/crew/ranks',
  suppliers: '/entities',
  crew: '/crew',
  users: '/admin/users',
  import_impa: '/admin/import-actions/impa-code',
  import_accounts_plan: '/admin/import-actions/accounts-plan',
  import_companies: '/admin/import-actions/companies',
  import_journals: '/admin/import-actions/journals',
  database_browser: '/admin/database-browser',
};

export function resolveLandingPathForModuleKey(moduleKey: string, vesselId?: number | null): string | undefined {
  const path = LANDING_MODULE_PATHS[moduleKey as LandingModuleKey];
  if (!path) return undefined;
  if (!path.includes(':id')) return path;
  const safeVesselId = vesselId != null && Number.isFinite(Number(vesselId)) && Number(vesselId) > 0
    ? Number(vesselId)
    : null;
  if (safeVesselId == null) return undefined;
  return path.replace(':id', String(safeVesselId));
}

/**
 * Get permission module key for a path. Checks exact match then prefix (e.g. /reports/... -> reports).
 */
export function getModuleKeyForPath(path: string): string | undefined {
  const normalized = path.split('?')[0];
  if (normalized.startsWith('/parameters/crew/') || normalized === '/parameters/crew') {
    return 'crew_parameters';
  }
  if (normalized === '/dashboard' || (normalized.includes('/vessel-modules/') && normalized.includes('/dashboard'))) {
    return 'vessel_dashboard';
  }
  if (
    normalized.startsWith('/spare-pending-deliveries') ||
    (normalized.includes('/vessel-modules/') && normalized.includes('/spare-pending-deliveries'))
  ) {
    return 'vessel_spare_pending_deliveries';
  }
  if (
    normalized.startsWith('/spare-requisitions') ||
    (normalized.includes('/vessel-modules/') && normalized.includes('/spare-requisitions'))
  ) {
    return 'vessel_spare_requisitions';
  }
  if (
    normalized.startsWith('/pending-deliveries') ||
    (normalized.includes('/vessel-modules/') && normalized.includes('/pending-deliveries'))
  ) {
    return 'vessel_pending_deliveries';
  }
  if (
    normalized.startsWith('/requisitions') ||
    (normalized.includes('/vessel-modules/') && normalized.includes('/requisitions'))
  ) {
    return 'vessel_supply_requisitions';
  }
  if (PATH_TO_MODULE_KEY[normalized]) return PATH_TO_MODULE_KEY[normalized];
  const segment = normalized.split('/').filter(Boolean)[0];
  if (!segment) return undefined;
  const byPrefix = Object.entries(PATH_TO_MODULE_KEY).find(
    ([p]) => p.startsWith('/' + segment) || normalized.startsWith(p),
  );
  return byPrefix?.[1];
}
